<div *ngIf="showSpinner" class="page-overlay-wrapper">
    <div class="loader"></div>
</div>